import { styled } from "@mui/system"
import { Box, TextField, Typography, TableHead } from "@mui/material"

export const SearchBar = styled(TextField)({
  width: "90%",
})

export const FilterInfoContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  marginBottom: "20px",
})

export const Text = styled(Typography)({
  fontSize: "14px",
})

export const BoldText = styled(Typography)({
  fontSize: "14px",
  fontWeight: "500",
  margin: "3px",
})

export const NoResults = styled(Typography)({
  paddingBlockStart: "20px",
})
